import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@fasstech/middle-design-system';

/**
 * Affichage en lecture seule de la date d'effet : la date formatée en texte
 * + un bouton crayon d'édition (raccourci vers la vue date d'effet), le tout
 * dans une bordure arrondie.
 */
const EffectDateEditField = ({
  label,
  value,
  onEdit,
  isProjectEditable = true,
  editIsLocked = false
}) => (
  <div className="relative flex h-10 w-full items-center justify-between gap-2 rounded-sm border border-gray-300 px-3">
    {label && value && (
      <label className="absolute left-2 top-[-10px] flex bg-white px-1 text-sm text-primary">
        {label}
      </label>
    )}
    <span className="text-sm">{value}</span>
    {isProjectEditable && (
      <Icon
        name="circlePen"
        size={24}
        className={`shrink-0 ${editIsLocked ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
        onClick={editIsLocked ? undefined : onEdit}
        data-testid="PROCESSDEVENTE_DATE_EFFET_EDIT"
      />
    )}
  </div>
);

EffectDateEditField.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  onEdit: PropTypes.func,
  isProjectEditable: PropTypes.bool,
  editIsLocked: PropTypes.bool
};

export default EffectDateEditField;
